export default __webpack_public_path__ + "images/3f96dddb80dd0a06eb9e5836cc641f33-generic_2_desktop.webp";